import ArrowCircleUp from '@mui/icons-material/ArrowCircleUp';
import React from 'react';

export const TOUR_STAGES = {
  ORG_SWITCHER: 'org-switcher',
  UPLOAD_AOI: 'upload-aois-button',
  COLLECTIONS: 'collection-header',
  OPEN_COLLECTION: 'open-collection-button',
  FEATURE_HEADER: 'feature-header',
  FEATURE_MORE_MENU_BUTTON: 'feature-more-menu-button',
  FEATURE_MORE_MENU_LIST: 'feature-more-menu-list',
};

export const EMPTY_STATE_STEPS = [
  {
    id: TOUR_STAGES.ORG_SWITCHER,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'bottom-end',
    target: `[data-tour="${TOUR_STAGES.ORG_SWITCHER}"]`,
    content:
      'View your current organization, which can be changed as an admin.',
  },
  {
    id: TOUR_STAGES.UPLOAD_AOI,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'right',
    target: `[data-tour="${TOUR_STAGES.UPLOAD_AOI}"]`,
    content: (
      <div>
        Start by uploading areas of interest to create a collection. You can
        also upload your AOIs in the top navigation bar by clicking{' '}
        <ArrowCircleUp fontSize="small" sx={{verticalAlign: 'middle'}} />
      </div>
    ),
  },
  {
    id: TOUR_STAGES.COLLECTIONS,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'right-start',
    target: `[data-tour="${TOUR_STAGES.COLLECTIONS}"]`,
    content:
      'Your collections will be viewable in a list that lets you manage individual features.',
  },
];

export const BEGIN_WORKFLOW = [
  {
    id: TOUR_STAGES.COLLECTIONS,
    disableBeacon: true,
    delay: 450,
    spotlightPadding: 4,
    placement: 'right-start',
    target: `[data-tour="${TOUR_STAGES.COLLECTIONS}"]`,
    content:
      'It’s easiest to show you around as part of a guided workflow. Would you like to walk through how to upload and learn about your first collection?',
  },
];

export const COLLECTION_TOUR_STEPS_PT1 = [
  {
    id: TOUR_STAGES.OPEN_COLLECTION,
    disableBeacon: true,
    delay: 300,
    spotlightPadding: 4,
    placement: 'right-start',
    target: `[data-tour="${TOUR_STAGES.OPEN_COLLECTION}"]`,
    spotlightClicks: true,
    content:
      'Open the collection to view features. You can also zoom to and toggle collection visibility. Click the "Open" Button',
  },
  {
    id: TOUR_STAGES.FEATURE_HEADER,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'top',
    target: `[data-tour="${TOUR_STAGES.FEATURE_HEADER}"]`,
    content:
      'Use filtering to refine your search for specific features by their name.',
    finishLabel: 'Next',
  },
];
const COLLECTION_TOUR_STEPS_PT2 = [
  {
    id: TOUR_STAGES.FEATURE_MORE_MENU_BUTTON,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'top',
    target: `[data-tour="${TOUR_STAGES.FEATURE_MORE_MENU_BUTTON}"]`,
    spotlightClicks: true,
    content: 'Click the highlighted button to see more options.',
    hideNextButton: true,
  },
  {
    id: TOUR_STAGES.FEATURE_MORE_MENU_LIST,
    disableBeacon: true,
    spotlightPadding: 4,
    placement: 'top',
    target: `[data-tour="${TOUR_STAGES.FEATURE_MORE_MENU_LIST}"]`,
    content: 'Here you can explore feature level actions.',
  },
];

export const TOURS = {
  EMPTY_STATE: 'empty-state',
  COLLECTION_TOUR_PT1: 'collection-tour-pt1',
  COLLECTION_TOUR_PT2: 'collection-tour-pt2',
};

export const TOUR_STEPS = {
  [TOURS.EMPTY_STATE]: EMPTY_STATE_STEPS,
  [TOURS.COLLECTION_TOUR_PT1]: COLLECTION_TOUR_STEPS_PT1,
  [TOURS.COLLECTION_TOUR_PT2]: COLLECTION_TOUR_STEPS_PT2,
};
